/**
 * The human-readable message of a caught value (`catch (e)` is `unknown`).
 * Covers Error instances and the plain `{ message }` objects Supabase / fetch
 * wrappers throw; a thrown string is returned as-is; anything else gives ''.
 * Returns '' rather than undefined so `errorMessage(e) || 'fallback'` reads
 * the same as the old `e.message || 'fallback'`.
 */
export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message
  if (e && typeof e === 'object' && 'message' in e && typeof (e as { message: unknown }).message === 'string') {
    return (e as { message: string }).message
  }
  return typeof e === 'string' ? e : ''
}
